module.exports = __webpack_public_path__ + "static/Start-Output-Month-cae9fb51346aa10bf8d7deff797af75b.png";